import React from "react";
import { FaWhatsapp } from "react-icons/fa";

const FloatingWhatsApp = () => {
  const phoneNumber = "918655557727";
  const message = encodeURIComponent(
    "Hi, I need appliance service. Please assist me.",
  );

  return (
    <>
      {/* Floating WhatsApp Button */}
      <a
        href={`https://wa.me/${phoneNumber}?text=${message}`}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 bg-green-500 hover:bg-green-600 text-white rounded-full p-4 shadow-2xl transition-all duration-300 hover:scale-110 animate-bounce"
        data-testid="floating-whatsapp-button"
        aria-label="Contact on WhatsApp"
      >
        <FaWhatsapp className="text-3xl" />
      </a>

      {/* Sticky Call Now Button (Mobile) */}
      <div className="md:hidden fixed bottom-24 left-0 right-0 z-40 px-4">
        <a
          href="tel:8655557727"
          className="flex items-center gap-3 w-full bg-blue-600 hover:bg-blue-700 text-white py-3 px-4 rounded-full shadow-xl font-bold text-base transition-all duration-300"
          data-testid="sticky-call-button"
        >
          {/* Owner + CEO Images */}
          <div className="flex -space-x-3">
            <img
              src="/Sagar_1.png"
              alt="Sagar Paswan - Owner"
              className="w-11 h-11 rounded-full border-2 border-white object-cover"
            />
            <img
              src="/Sachin_half.png"
              alt="CEO"
              className="w-11 h-11 rounded-full border-2 border-white object-cover"
            />
          </div>

          {/* Call Text */}
          <span className="flex-1 text-center leading-tight">
            📞 Call Now: +91 8655557727
          </span>
        </a>
      </div>
    </>
  );
};

export default FloatingWhatsApp;
